/* eslint-disable no-unused-vars */
import {
  CircularProgress,
  Grid,
  Icon,
  IconButton,
  Typography,
} from "@mui/material";
import PCheck from "../../../components/pos/PCheck";
import PConfirm from "../../../components/pos/PConfirm";
import PDialog from "../../../components/pos/PDialog";
import PRSelect from "../../../components/pos/PRSelect";
import PText from "../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { SyncUtils } from "../../../utils/SyncUtils";
import SyncIcon from "@mui/icons-material/Sync";
import { PrintUtils } from "../../../utils/PrintUtils";
import axios from "axios";
import { red } from "@mui/material/colors";
import { SaleUtils } from "../../../utils/SaleUtils";

export default function TerminalCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState(translate("New KOT Printer"));
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const [printerOptions, setPrinterOptions] = useState([]);
  const [kotPrinter, setkotPrinter] = useState(null);
  const [kotPrinterError, setkotPrinterError] = useState(null);

  const [loadFlag, setLoadFlag] = useState([]);

  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.child = {
    showTerminalCrudWindow: showTerminalCrudWindow,
  };

  useEffect(() => {}, []);

  useEffect(() => {
    if (liveValidation && name === "")
      setNameError(translate("Name is Required"));
    else setNameError("");
  }, [name]);

  useEffect(() => {
    if (liveValidation && kotPrinter === "")
      setkotPrinterError(translate("Kot Printer is Required"));
    else setkotPrinterError("");
  }, [kotPrinter]);

  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  async function showTerminalCrudWindow(terminalId) {
    let kotPrinters = await refreshCloudPrinters();
    if (terminalId == null) {
      resetFields();
      setMode("create");
      setLiveValidation(false);
      setOpenWindow(true);
    } else {
      setMode("edit");
      populateTerminal(terminalId, kotPrinters);
    }
  }
  async function populateTerminal(id, kotPrinters) {
    {
      try {
        let { data } = await API.get("/api/v1/kotprinter/" + id);
        setOrigObject(data);
        populateData(data, kotPrinters);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Terminal data from server")
        );
      }
    }
  }

  async function populateData(bean, kotPrinters) {
    setWindowTitile(bean.name);
    setName(bean.name);
    setkotPrinter(SaleUtils.getOption2(kotPrinters, bean.cloudPrinterId));
    //setkotPrinter(p);

    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setName("");
    setNameError("");
    setkotPrinter(null);
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete KOT Printer") +
        " :" +
        origObject.name +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/api/v1/kotprinter/" + origObject.id);
        props.showMessage(
          "warning",
          translate("Terminal") + " " + name + " " + translate("got Removed")
        );
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage("error", translate("Not able to Delete Terminal"));
      }
    }
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        let result = await API.post("/api/v1/kotprinter", payload);
        props.showMessage("success", translate("Saved Successfully"));
        //SyncUtils.requestSync(result.headers);
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        console.log(err);
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", translate("Not able to Save KOT Printer"));
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }
      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    console.log(mode);
    saveObject["name"] = name;
    console.log(kotPrinter);
    saveObject["cloudPrinterId"] = kotPrinter ? kotPrinter.value : null;

    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }
    return saveObject;
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError(translate("Name is Required"));
      flag = false;
    }

    if (!kotPrinter || kotPrinter === "") {
      setkotPrinterError(translate("KOT Printer is Required"));
      flag = false;
    }

    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  async function refreshCloudPrinters() {
    console.log("Refreshy refreshCloudPrinters");

    try {
      props.showProgress("Loading Cloud Printers");
      let kotPrinters = [];

      let [url, token] = await PrintUtils.getCloudPrintToken();
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      let devices = await axios.get(
        "/cloudprintbackend/api/v1/core/devices",
        config
      );

      console.log(devices);
      for (let device of devices.data) {
        console.log(device);
        if (device.deviceFamily === "PRINTER") {
          kotPrinters.push({
            value: device.id,
            label: device.name,
          });
        }
      }
      setPrinterOptions(kotPrinters);

      setLoadFlag("Y");
      props.hideProgress();
      return kotPrinters;
    } catch (err) {
      props.hideProgress();
      props.showMessage("error", "Not able to load cloud printers", err);
      console.error("##", err);
      setLoadFlag("F");
    }
  }

  const content = (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Name")} <sup style={{ color: "red" }}>*</sup>
                  </Typography>
                </td>
                <td>
                  <PText
                    value={name}
                    error={nameError}
                    onChange={(e) => setName(e.target.value)}
                  ></PText>
                </td>
              </tr>
              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12} sm={6}>
          <table width="100%">
            <tbody>
              <tr>
                <td>Receipt Printer</td>
                <td style={{ width: "300px" }}>
                  <PRSelect
                    options={printerOptions}
                    onChange={(e) => {
                      setkotPrinter(e);
                    }}
                    value={kotPrinter}
                  ></PRSelect>
                  <div style={{ color: "red", fontSize: "0.7rem" }}>
                    {kotPrinterError}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    if (mode === "create") {
      if (name || name != "") return true;
    }
    if (mode === "edit") {
      if (name !== origObject.name) return true;
    }
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          onDelete={onDelete}
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
